export default function renderBr() {
  return this.options.xhtml ? '<br/>' : '<br class="smartdown_br">';
}
